module.exports = __webpack_public_path__ + "static/media/jnj2.dec69506.png";